/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { http } from "@/api/index";

import {
	GET_WIND_ISO_LIMITS,
	GET_WIND_ISO_LIMITS_SUCCESS,
	GET_WIND_ISO_LIMITS_ERROR,
} from "@/stores/actions/WindISO1081621Limits";

const state = {
	status: FetchStatus.Init,
	error:  {},
	data:   {},
};

const actions = {

	[GET_WIND_ISO_LIMITS]: ({ commit }, monitoringElementId) =>
	{
		commit(GET_WIND_ISO_LIMITS);
		http.get(`/WindISO1081621Limits/${monitoringElementId}`)
			.then((resp) =>
			{
				commit(GET_WIND_ISO_LIMITS_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_WIND_ISO_LIMITS_ERROR, error.response);
			});
	},

};
const mutations = {
	[GET_WIND_ISO_LIMITS]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_WIND_ISO_LIMITS_SUCCESS]: (state, resp) =>
	{
		state.data = resp;
		state.status = FetchStatus.Loaded;
	},
	[GET_WIND_ISO_LIMITS_ERROR]: (state, error) =>
	{
		state.error = error;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
